export const buildTime = '2026-10-02 12:30:24 UTC';
